import { useTranslation } from 'react-i18next';
import { useAlert } from 'shared/components/alerts';
import { useCallback, useState } from 'react';
import { useRenderDocument } from '../../../commons/hooks/use-render-document/use-render-document';

export const useDisplayDocument = (documentId: string) => {
  const { t } = useTranslation('web-common');
  const { refetch, isFetching } = useRenderDocument(documentId, { enabled: false });
  const { alertError } = useAlert();
  const [isOpening, setIsOpening] = useState(false);

  const handleDownload = useCallback(async () => {
    setIsOpening(true);
    try {
      const response = await refetch();
      const url = response.data?.url;

      if (url) {
        window.open(url, '_blank');
      } else {
        alertError(new Error(t('documents.alerts.download_error', { ns: 'web-common' })));
      }
    } catch (err: any) {
      alertError(err);
    } finally {
      setIsOpening(false);
    }
  }, [isOpening, isFetching, refetch, alertError, t]);

  return { handleDownload, isDownloading: isOpening || isFetching };
};
